import styled from "styled-components";



export const AlertDialogModal = styled.div`
  min-width: 450px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const AlertDialogTitle = styled.div`
  font-size: 20px;
  color: #002E5C;
  font-weight: 700;
`;

export const AlertDialogDescription = styled.p`
  font-size: 16px;
  color: #002E5C;
  font-weight: 400;
  width: 90%;
  text-align: center;
`;

export const AlertDialogActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`


export const AlertDialogButton = styled.button`
    height: 44px;
    border-radius: 5px;
    padding: 0 1rem;
    min-width: 100px;
    font-size: 14px;
    font-weight: 700;
    font-family: "Poppins";
    background-color: ${({ theme }) => theme === "primary" ? "#2555EF" : "#2555ef14"};
    color: ${({ theme }) => theme === "primary" ? "#FFFFFF" : "#2555EF"};

    opacity: ${({ disabled }) => disabled ? "0.5" : "1"};
`;